<template>
	<div class="inner">
		<v-client-table :columns="columns" :data="billings" :options="options" ref="table" class="billings-table">

			<div slot="beforeFilter" class="intro">
                <h1>{{$t('billings.headline')}}</h1>
            </div>
            <div slot="afterFilter" class="add-button">
                <div class="icon">
                	<simple-svg
                    	:filepath="'/images/SVG/Search.svg'"
                    	:width="'20px'"
                    	:height="'20px'"
                                    
                	/>
            	</div>
            </div>
            <a slot="more" slot-scope="props">
                <table-dropdown>
                    <li>link 1</li>
                    <li>link 2</li>
                </table-dropdown>
            </a>
			
		</v-client-table>
	</div>
</template>
<script>
	import Vue from 'vue';
    import {ClientTable} from 'vue-tables-2';
    import {mapGetters} from 'vuex';
    import TableDropdown from '../../components/TableDropdown'

    Vue.use(ClientTable);

    export default {
    	components: {
    		TableDropdown
    	},
    	data: () => ({
    		billings: [],
    		columns: ['product', 'address', 'city', 'quantity', 'price', 'date', 'more'],
    		options: {
    			headings: {
    				product: 'Product',
    				address: 'Address',
    				city: 'City',
    				quantity: 'Quantity',
    				price: 'Price',
    				date: 'Date',
    				more: 'More'
    			},
    			sortable: ['address', 'date'],
    			filterable: ['address', 'city', 'date'],
    			texts:{
                    filterPlaceholder: 'Search',
                    filter: '',
                    noResults: ''
                },
                columnsClasses: {
                	product: 'product',
                	address: 'address',
                	city: 'city',
                	quantity: 'text-right',
                	price: 'text-right',
                	date: 'text-right',
                	more: 'more' 
                }
    		}
    	}),
        created(){
            this.options.texts.noResults = this.$t('table.no-results.label');
            this.options.texts.filterPlaceholder = this.$t('search.filterplaceholder');

            this.options.headings.product = this.$t('billings.table.product');
            this.options.headings.address = this.$t('billings.table.address');
            this.options.headings.city = this.$t('billings.table.city');
            this.options.headings.quantity = this.$t('billings.table.quantity');
            this.options.headings.price = this.$t('billings.table.price');
            this.options.headings.date = this.$t('billings.table.date');
        }
    }
</script>
<style></style>